import { useContext } from 'react';
import UserContext from 'src/context/UserProvider';

export const useUser = () => {
  const user = useContext(UserContext);
  return user;
};
